export default __webpack_public_path__ + "static/media/hand_up.86995a47.svg";